import React from "react";
import { Route, Switch } from "react-router-dom";
import Account from "../components/accounts/Account";
import PrivateRoute from "../components/auth/PrivateRoute";
import Help from "../components/help/index";
import Management from "../components/management/Management";
import { amRoutes, managementTabs } from "../config/config";
import AcceptInvitationView from "../views/AcceptInvitationView";
import ConfirmPasswordResetView from "../views/ConfirmPasswordResetView";
import ConfirmRegistrationView from "../views/ConfirmRegistration";
import CreateAccountView from "../views/CreateAccountView";
import LoginView from "../views/LoginView";
import MainView from "../views/MainView";
import RegisterAccountView from "../views/RegisterAccount";

const mainViewRoutes = (
  <Switch>
    <PrivateRoute
      path={amRoutes.managementUsers}
      render={props => <Management {...props} activeTab={managementTabs.users} />}
    />
    <PrivateRoute
      path={amRoutes.managementPermissions}
      render={props => <Management {...props} activeTab={managementTabs.permissions} />}
    />
    <PrivateRoute
      path={amRoutes.managementSubscription}
      render={props => <Management {...props} activeTab={managementTabs.subscription} />}
    />
    <PrivateRoute
      allowPublic
      path={amRoutes.managementRegions}
      render={props => <Management {...props} activeTab={managementTabs.regions} />}
    />
    <PrivateRoute
      allowPublic
      path={amRoutes.managementSettings}
      render={props => <Management {...props} activeTab={managementTabs.settings} />}
    />
    <PrivateRoute
      path={amRoutes.managementSecurity}
      render={props => <Management {...props} activeTab={managementTabs.security} />}
    />
    <PrivateRoute
      path={amRoutes.management}
      render={props => <Management {...props} activeTab={undefined} />}
    />
    <PrivateRoute allowPublic path={amRoutes.profile} render={props => <Account {...props} />} />
    <PrivateRoute path={amRoutes.help} render={() => <Help />} />
    <PrivateRoute path={amRoutes.dashboard} render={props => <Account {...props} />} />
  </Switch>
);

const routes = (
  <Switch>
    <Route path={amRoutes.login} render={props => <LoginView {...props} />} />
    <Route path={amRoutes.registration} render={() => <RegisterAccountView />} />
    <Route path={amRoutes.accountCreate} render={props => <CreateAccountView {...props} />} />
    <Route path={amRoutes.acceptInvitation} render={props => <AcceptInvitationView {...props} />} />
    <Route
      path={amRoutes.confirmRegistration}
      render={props => <ConfirmRegistrationView {...props} />}
    />
    <Route
      path={amRoutes.confirmPasswordReset}
      render={props => <ConfirmPasswordResetView {...props} />}
    />
    <PrivateRoute
      allowPublic
      path={amRoutes.dashboard}
      render={props => <MainView {...props} routes={mainViewRoutes} />}
    />
  </Switch>
);

export default routes;
